import { render } from "./IqacNoticesView.vue?vue&type=template&id=99cad2b8"
import script from "./IqacNoticesView.vue?vue&type=script&lang=js"
export * from "./IqacNoticesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__